import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const COLOR_REQUESTS = '#3b82f6';
const COLOR_ERRORS = '#dc3545';
const COLOR_BANDWIDTH = '#30d7e3';
const COLOR_LATENCY = '#bbbbbb';

function formatTimeLabel(value) {
  const date = new Date(value.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('vi-VN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function UsageChart({ timeseries }) {
  const data = Object.entries(timeseries || {}).map(([time, values]) => {
    const totalRequests = values.ok_count + values.fail_count;
    return {
      minute: formatTimeLabel(time),
      total_requests: totalRequests,
      error_requests: values.fail_count,
      avg_latency: values.avg_latency,
      kbytes_per_request: totalRequests > 0 ? values.total_bytes / 1024 / totalRequests : 0,
    };
  });

  return (
    <div className="rounded-2xl border border-cyan-100 bg-white p-5">
      <h3 className="mb-4 text-sm font-semibold text-slate-900">Requests / Errors / Latency / Bandwidth</h3>
      <div className="h-[400px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} isAnimationActive={false}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="minute" tick={{ fontSize: 11 }} minTickGap={24} />

            <Tooltip isAnimationActive={false} />

            <YAxis
              yAxisId="y_requests"
              label={{
                value: 'Requests count',
                angle: -90,
                position: 'insideLeft',
                style: { fill: COLOR_REQUESTS },
              }}
              stroke={COLOR_REQUESTS}
            />

            <YAxis
              yAxisId="y_avg_latency"
              orientation="right"
              label={{
                value: 'Avg Delay (ms)',
                angle: 90,
                position: 'insideRight',
                offset: 80,
                style: { fill: COLOR_LATENCY },
              }}
            />

            <YAxis
              yAxisId="y_kbytes_per_request"
              orientation="right"
              label={{
                value: 'KB/request',
                angle: 90,
                position: 'insideRight',
                offset: 25,
                style: { fill: COLOR_BANDWIDTH },
              }}
              stroke={COLOR_BANDWIDTH}
            />

            <Line
              yAxisId="y_requests"
              type="monotone"
              dataKey="total_requests"
              stroke={COLOR_REQUESTS}
              strokeWidth={2}
              name="Totals"
              unit={' request(s)'}
              dot={false}
              isAnimationActive={false}
            />

            <Line
              yAxisId="y_requests"
              type="monotone"
              dataKey="error_requests"
              stroke={COLOR_ERRORS}
              strokeWidth={2}
              name="Errors"
              unit={' request(s)'}
              dot={false}
              isAnimationActive={false}
            />

            <Line
              yAxisId="y_kbytes_per_request"
              type="monotone"
              dataKey="kbytes_per_request"
              stroke={COLOR_BANDWIDTH}
              strokeWidth={1}
              name="Avg Bandwidth"
              unit={' KB/request'}
              dot={false}
              isAnimationActive={false}
            />

            <Bar
              yAxisId="y_avg_latency"
              dataKey="avg_latency"
              fill={COLOR_LATENCY}
              name="Avg Latency"
              barSize={3}
              unit={'ms'}
              isAnimationActive={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
